import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './BackArrow.css';

function BackArrow({ to, color, onBeforeNavigate }) {
  const navigate = useNavigate();
  const [top, setTop] = useState(0);
  const [headingColor, setHeadingColor] = useState('');
  const [isMobile, setIsMobile] = useState(typeof window !== 'undefined' && window.innerWidth <= 600);

  useEffect(() => {
    const updatePosition = () => {
      const heading = document.querySelector('.section-title');
      if (heading) {
        // offsetTop statt getBoundingClientRect: misst im Koordinatensystem
        // des positionierten Layout-Wrappers (.kernteam-layout-content), auf
        // den sich auch das absolute top dieses Pfeils bezieht. Die frühere
        // Dokument-Koordinaten-Rechnung saß deshalb um Navbar-Höhe zu tief.
        // Anker = Unterkante der h1; mit translateY(-100%) im CSS schließt
        // der Pfeil bündig mit der Unterkante des Titels ab.
        setTop(heading.offsetTop + heading.offsetHeight);
        setHeadingColor(getComputedStyle(heading).color);
      }
      setIsMobile(window.innerWidth <= 600);
    };
    updatePosition();
    window.addEventListener('resize', updatePosition);
    return () => window.removeEventListener('resize', updatePosition);
  }, []);

  return (
    <div
      className={`back-arrow ${color}`}
      style={{
        top: isMobile ? 'auto' : `${top}px`,
        position: isMobile ? 'static' : 'absolute',
        color: headingColor,
      }}
      onClick={() => {
        if (!onBeforeNavigate || onBeforeNavigate()) {
          navigate(to);
        }
      }}
    >
      <span className="material-symbols-outlined">arrow_back</span>
      <span className="back-text">ZURÜCK</span>
    </div>
  );
}

export default BackArrow;
